import _omit2 from "lodash/omit";
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { push } from 'react-router-redux';
import { browserHistory } from 'react-router';
import { editFieldActionFactory, editShippingCountryFactory, editShippingStateFactory, setAddressAction, setShippingValidationError, shippingNameEditActionFactory, updateShippingNameFactory } from 'swag-client-common/redux/partials/shipping-form/shipping-form.actions';
import { GiveawayLinkStatus } from 'swag-common/constants/giveaway.constants';
import { GiveawayUrl } from 'swag-common/utils/urls/giveaway.url';
import { getDefaultValue as getDefaultStateForCountry } from 'swag-common/utils/shipping';
import { createAsyncLoadedAction } from 'swag-client-common/utils/create-async-loaded-actions.utils';
import { createAsyncAction } from 'swag-client-common/libs/redux-helpers';
import { getAllCategories } from 'swag-client-common/redux/goodie-giveaway/actions/goodie-giveaway-categories.actions';
import { setSelectedGoodieProductsList } from 'swag-client-common/redux/goodie-giveaway/actions/goodie-giveaway-selection.actions';
import { setGoodieGiveawaySelectedProducts } from 'swag-client-common/utils/local-storage.util';
import { checkIsGiveawayWithSwagType, checkIsGiveawayWithGoodieType } from 'swag-common/utils/giveaway/giveaway-type.util';
import { saveGiveawayModelActionFactory } from 'swag-client-common/redux/partials/giveaway-selected/giveaway-selected.actions';
import { GiveawayPopups } from 'swag-common/constants/giveaway.constants';
import { GiveawayGoodieSteps } from 'swag-common/interfaces';
import { isGiveawayEnded } from 'swag-common/business-logic/giveaway/is-giveaway-ended';
import { CONFIRM_GOODIE_UNUSED_BUDGET_POPUP, DEMO_INVENTORY_WARNING_POPUP } from 'swag-client-common/constants';
import { showManualAddressEnterPopup } from 'swag-client-common/redux/partials/autocomplete/autocomplete.action';
import { hidePopup, showPopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { isAddressNotFoundByError, isAddressSuggestedByError } from 'swag-client-common/utils/manual-address-enter.utils';
import { getAutocompleteAddressPayload, getAddressesFromStateForAutocompleteSelection, checkIsAddressValidationNeeded } from 'swag-client-common/redux/partials/autocomplete/autocomplete.utils';
import { isGiveawaySuspended } from 'swag-common/business-logic/giveaway/is-giveaway-suspended';
import { validateZipCodeByCountry } from 'swag-client-common/utils/validate-zip-code-by-country';
import { DeliveryKeys } from 'swag-client-common/constants/delivery';
import { showNotification } from 'swag-client-common/redux/notification/notification.actions';
import { selectedGoodieProductsIdsSelector } from 'swag-client-common/redux/goodie-giveaway/selectors/goodie-giveaway-selection.selectors';
import { FORBIDDEN_ERROR_CODE } from 'swag-common/constants/error-codes';
import { GiveawayPageStatus } from '../../components/partials/giveaway-page-resolver/giveaway-page-resolver';
import { scrollWindowToTopAction } from '../../../custom-store-admin/middleware/window-manipulations.middleware';
import { ScrollBlockId, windowScrollToBlock } from '../../middleware/window-manipulations.middleware';
import { GiveawayApi } from '../../api/giveaway.api';
import { pathnameSelector } from '../routing/routing.selectors';
import { removeGiveawayLandingActiveItemActionFactory, setGiveawayLandingActiveItemActionFactory } from './giveaway-selected-item.actions';
import { setGiveawayLandingVariantColorTypeCreator, setGiveawayLandingVariantSizeActionFactory } from './giveaway-color-and-size-variants.actions';
import { currentGiveawayVariantsSelector, giveawayLinkItemItemSelector, giveawayLinkRouteSelector, giveawayLinkToGoSelector, giveawayLinkUpdateRequestedItemSelector, giveawayVariantsToSendSelector, selectedGiveawaySelector, selectedGiveawayTypeSelector, selectedItemsSelector, shippingAddressValuesSelector, shouldShowGoodieBudgetConfirmationPopup } from './giveaway-landing.selectors';
import { selectedOptionSelector, isAddressEnteredManuallySelector } from './reducers/autocomplete/autocomplete.selectors';
import { isGiveawayCompleted } from './utils/is-giveaway-completed';
import { isGiveawayDeleted } from './utils/is-giveaway-deleted';
import { isGiveawayLinkCompleted } from './utils/is-giveaway-link-completed';
import { getNextProductSelections } from './utils/get-next-product-selections.util';
import { mergeGiveawayDraftFieldsWithProducts } from './utils/merge-giveaway-draft-fields-with-products';
export const GIVEAWAY_LANDING_STORE_PREFIX = 'GIVEAWAY_LANDING_STORE_PREFIX_';
export const editFieldAction = editFieldActionFactory(GIVEAWAY_LANDING_STORE_PREFIX);
export const validateShippingField = (field, value) => (dispatch, getState) => {
  if (field === DeliveryKeys.Zip) {
    const {
      country
    } = shippingAddressValuesSelector(getState());
    const zipError = validateZipCodeByCountry(value, country);
    dispatch(setShippingValidationError(field, zipError));
  }
};
export const editShippingCountryAction = editShippingCountryFactory(GIVEAWAY_LANDING_STORE_PREFIX);
export const editShippingStateAction = editShippingStateFactory(GIVEAWAY_LANDING_STORE_PREFIX);
export const updateShippingNameAction = updateShippingNameFactory(GIVEAWAY_LANDING_STORE_PREFIX);
export const shippingNameEditAction = shippingNameEditActionFactory(GIVEAWAY_LANDING_STORE_PREFIX);
export const editCountryAction = newCountry => (dispatch, getState) => {
  const reduxState = getState();
  const {
    country,
    zip
  } = shippingAddressValuesSelector(reduxState);
  dispatch(editShippingCountryAction(newCountry));
  if (country !== newCountry) {
    const state = getDefaultStateForCountry(newCountry);
    dispatch(editShippingStateAction(state));
    const zipError = validateZipCodeByCountry(zip, newCountry);
    const isAddressEnteredManually = isAddressEnteredManuallySelector(reduxState);
    if (isAddressEnteredManually) {
      dispatch(setShippingValidationError('zip', zipError));
    }
  }
};
export const goToGiveawayUserSuccessPage = link => (dispatch, getState) => {
  const state = getState();
  const giveawayType = selectedGiveawayTypeSelector(state);
  const lintToGo = giveawayLinkToGoSelector(link)(state);
  dispatch(push(GiveawayUrl.getGiveawayUserLandingSuccess(lintToGo, giveawayType)));
  dispatch(scrollWindowToTopAction());
};
export const goToGiveawayUserDeletedPage = link => (dispatch, getState) => {
  const state = getState();
  const giveawayType = selectedGiveawayTypeSelector(state);
  const lintToGo = giveawayLinkToGoSelector(link)(state);
  dispatch(push(GiveawayUrl.getGiveawayUserLandingDeleted(lintToGo, giveawayType)));
  dispatch(scrollWindowToTopAction());
};
export const goToGiveawayUserLandingPage = link => (dispatch, getState) => {
  const state = getState();
  const giveawayType = selectedGiveawayTypeSelector(state);
  const lintToGo = giveawayLinkToGoSelector(link)(state);
  dispatch(push(GiveawayUrl.getGiveawayUserLanding({
    link: lintToGo,
    giveawayType
  })));
  dispatch(scrollWindowToTopAction());
};
export const goToGiveawayUserEndedPage = link => (dispatch, getState) => {
  const state = getState();
  const giveawayType = selectedGiveawayTypeSelector(state);
  const lintToGo = giveawayLinkToGoSelector(link)(state);
  dispatch(push(GiveawayUrl.getGiveawayUserLandingEnded(lintToGo, giveawayType)));
  dispatch(scrollWindowToTopAction());
};
export const goToGiveawaySuccessPage = (inventoryId, giveawayId) => dispatch => {
  dispatch(push(GiveawayUrl.getGiveawayPreviewSuccess(inventoryId, giveawayId)));
  dispatch(scrollWindowToTopAction());
};
export const getGiveawayById = createAsyncLoadedAction({
  fn: GiveawayApi.getById,
  success: giveaway => dispatch => {
    dispatch(saveGiveawayModelActionFactory(GIVEAWAY_LANDING_STORE_PREFIX)(mergeGiveawayDraftFieldsWithProducts(giveaway, true)));
  },
  error: () => push(GiveawayUrl.notFound())
});
export function setGiveawayLandingVariantColor(productId, color, isOneProduct) {
  return (dispatch, getState) => {
    const state = getState();
    dispatch({
      type: setGiveawayLandingVariantColorTypeCreator(GIVEAWAY_LANDING_STORE_PREFIX),
      payload: getNextProductSelections({
        giveawayColorAndSizeVariantsState: currentGiveawayVariantsSelector(state),
        giveawaySelectedItemsState: selectedItemsSelector(state)
      }, {
        productId,
        color,
        isOneProduct
      })
    });
  };
}
export const setGiveawayLandingVariantSize = setGiveawayLandingVariantSizeActionFactory(GIVEAWAY_LANDING_STORE_PREFIX);
export const setGiveawayLandingActiveItem = setGiveawayLandingActiveItemActionFactory(GIVEAWAY_LANDING_STORE_PREFIX);
export const removeGiveawayLandingActiveItem = removeGiveawayLandingActiveItemActionFactory(GIVEAWAY_LANDING_STORE_PREFIX);
export const SAVE_GIVEAWAY_LINK = `${GIVEAWAY_LANDING_STORE_PREFIX}SAVE_GIVEAWAY_LINK`;
export const saveGiveawayLink = giveawayLink => ({
  type: SAVE_GIVEAWAY_LINK,
  payload: {
    _id: giveawayLink._id,
    link: giveawayLink.link,
    status: giveawayLink.status,
    type: giveawayLink.type,
    isDemo: giveawayLink.isDemo,
    feedback: giveawayLink.feedback
  }
});
const saveGiveawayAndLinkData = (giveawayModel, giveawayLink) => dispatch => {
  dispatch(saveGiveawayModelActionFactory(GIVEAWAY_LANDING_STORE_PREFIX)(giveawayModel));
  dispatch(saveGiveawayLink(giveawayLink));
};
export const getGiveawayByLinkAction = ({
  pageStatus,
  link,
  giveawayType
}) => createAsyncLoadedAction({
  fn: GiveawayApi.getGiveawayLink,
  success: giveawayResponse => dispatch => {
    const {
      giveaway
    } = giveawayResponse;
    const giveawayLink = _omit2(giveawayResponse, ['giveawayId']);
    const giveawayModel = mergeGiveawayDraftFieldsWithProducts(giveaway, true);
    const isLinkCompleted = !!giveawayLink && !!giveawayLink.status && isGiveawayLinkCompleted(giveawayLink.status);
    const isCompleted = !!giveawayModel && !!giveawayModel.step && isGiveawayCompleted(giveawayModel.step);
    const isEnded = !!giveawayModel && !!giveawayModel.step && isGiveawayEnded(giveawayModel.step) || isGiveawaySuspended(giveawayModel.step) && giveawayResponse.isSingleLink;
    const isDeleted = !!giveawayModel && !!giveawayModel && isGiveawayDeleted(giveawayModel);
    const isGoodie = checkIsGiveawayWithGoodieType(giveaway);
    if (isGoodie) {
      dispatch(getAllCategories({
        onlyWithProducts: true
      }));
      if (giveawayLink.link) {
        dispatch(setSelectedGoodieProductsList(giveawayLink.link));
      }
    }
    dispatch(saveGiveawayAndLinkData(giveawayModel, giveawayLink));
    if (isDeleted) {
      if (pageStatus === GiveawayPageStatus.deleted) {
        return dispatch(saveGiveawayAndLinkData(giveawayModel, giveawayLink));
      }
      return dispatch(goToGiveawayUserDeletedPage(giveawayLink.link));
    }
    if (isLinkCompleted) {
      if (pageStatus === GiveawayPageStatus.completed) {
        return dispatch(saveGiveawayAndLinkData(giveawayModel, giveawayLink));
      }
      return dispatch(goToGiveawayUserSuccessPage(giveawayLink.link));
    }
    if (isEnded) {
      if (pageStatus === GiveawayPageStatus.ended) {
        return dispatch(saveGiveawayAndLinkData(giveawayModel, giveawayLink));
      }
      return dispatch(goToGiveawayUserEndedPage(giveawayLink.link));
    }
    if (isCompleted) {
      if (pageStatus === GiveawayPageStatus.landing) {
        return dispatch(saveGiveawayAndLinkData(giveawayModel, giveawayLink));
      }
      return dispatch(goToGiveawayUserLandingPage(giveawayLink.link));
    }
  },
  error: () => push(GiveawayUrl.notFound(giveawayType))
})({
  link,
  giveawayType
});
export const SET_GIVEAWAY_COMPLETED_STATUS = `${GIVEAWAY_LANDING_STORE_PREFIX}SET_GIVEAWAY_COMPLETED_STATUS`;
export const SET_GIVEAWAY_LANDING_ANSWER_ERROR = `${GIVEAWAY_LANDING_STORE_PREFIX}SET_GIVEAWAY_LANDING_ANSWER_ERROR`;
export const setAnswerErrorAction = error => ({
  type: SET_GIVEAWAY_LANDING_ANSWER_ERROR,
  payload: error
});
export const SET_GIVEAWAY_ID = `${GIVEAWAY_LANDING_STORE_PREFIX}SET_GIVEAWAY_ID`;
export const setGiveawayId = linkId => ({
  type: SET_GIVEAWAY_ID,
  payload: linkId
});
export const saveAnswer = createAsyncLoadedAction({
  preFn: (dispatch, getState) => {
    const item = giveawayLinkItemItemSelector(getState());
    if (item && item.isDemo) {
      dispatch(showPopup({
        popup: DEMO_INVENTORY_WARNING_POPUP
      }));
      return true;
    }
  },
  transformData: (data = {
    isAddressEnteredManually: false
  }, getState) => {
    const state = getState();
    const giveaway = selectedGiveawaySelector(state);
    const isAutoCompleteTurnedOff = isAddressEnteredManuallySelector(state);
    const item = giveawayLinkItemItemSelector(state);
    const shipping = _objectSpread({}, shippingAddressValuesSelector(state));
    shipping.firstName = shipping.fnameShipping;
    shipping.lastName = shipping.lnameShipping;
    delete shipping.fnameShipping;
    delete shipping.lnameShipping;
    delete shipping.zipError;
    const products = checkIsGiveawayWithSwagType(giveaway) ? giveawayVariantsToSendSelector(state) : selectedGoodieProductsIdsSelector(state);
    const isAddressEnteredManually = !checkIsAddressValidationNeeded({
      isAutoCompleteTurnedOff,
      isManualAddressConfirmed: Boolean(data.isAddressEnteredManually),
      shippingForm: shipping,
      autocompleteSelection: selectedOptionSelector(state)
    });
    return _objectSpread({}, shipping, {
      products,
      link: item === null || item === void 0 ? void 0 : item.link,
      isAddressEnteredManually: isAddressEnteredManually
    });
  },
  fn: GiveawayApi.saveAnswer,
  success: ({
    linkId
  }, data, dispatch) => {
    dispatch(setGiveawayId(linkId));
    dispatch(goToGiveawayUserSuccessPage(data.link));
  },
  error: (error, transformedData, dispatch) => {
    if (isAddressSuggestedByError(error)) {
      dispatch(openManualAddressEnterPopup(error.address));
    } else if (isAddressNotFoundByError(error)) {
      dispatch(openManualAddressErrorPopup());
    } else if (error.status === 422 && error.message) {
      return setAnswerErrorAction(error.message);
    } else if (error.status === FORBIDDEN_ERROR_CODE && error.message === 'Sorry that gift giveaway was deleted') {
      return push(GiveawayUrl.getGiveawayUserLandingDeleted(transformedData.link));
    }
    if ((error.status === FORBIDDEN_ERROR_CODE || error.status === 400) && error.message) {
      return setAnswerErrorAction(error.message);
    }
    return;
  },
  postSuccess: dispatch => {
    dispatch({
      type: SET_GIVEAWAY_COMPLETED_STATUS
    });
  },
  postError: dispatch => {
    dispatch(windowScrollToBlock(ScrollBlockId.giveawayValidationBlock));
  }
});
export const SET_GIVEAWAY_LINK_STATUS_REQUEST = `${GIVEAWAY_LANDING_STORE_PREFIX}SET_GIVEAWAY_LINK_STATUS_REQUEST`;
export const SET_GIVEAWAY_LINK_STATUS_SUCCESS = `${GIVEAWAY_LANDING_STORE_PREFIX}SET_GIVEAWAY_LINK_STATUS_SUCCESS`;
export const SET_GIVEAWAY_LINK_STATUS_FAILURE = `${GIVEAWAY_LANDING_STORE_PREFIX}SET_GIVEAWAY_LINK_STATUS_SUCCESS`;
export const registerLinkOpeningAction = createAsyncAction({
  preFn: (dispatch, getState) => {
    const state = getState();
    const link = giveawayLinkItemItemSelector(state);
    const updateRequested = giveawayLinkUpdateRequestedItemSelector(state);
    if (!link || link.status !== GiveawayLinkStatus.NEW || updateRequested || link.isDemo) {
      return true;
    }
    dispatch({
      type: SET_GIVEAWAY_LINK_STATUS_REQUEST
    });
  },
  transformData: (data, getState) => {
    const link = giveawayLinkItemItemSelector(getState());
    return {
      linkId: String(link === null || link === void 0 ? void 0 : link._id),
      status: GiveawayLinkStatus.OPENED
    };
  },
  fn: GiveawayApi.setLinkStatus,
  success: () => ({
    type: SET_GIVEAWAY_LINK_STATUS_SUCCESS
  }),
  error: error => ({
    type: SET_GIVEAWAY_LINK_STATUS_FAILURE,
    error
  })
});
export const openGiveawayProductImage = (image, name) => {
  return showPopup({
    popup: GiveawayPopups.GIVEAWAY_LINK_PRODUCT_IMAGE_POPUP,
    image,
    name
  });
};
const resendAnswer = (type, isAddressEnteredManually) => dispatch => {
  dispatch(hidePopup());
  dispatch(saveAnswer({
    isAddressEnteredManually
  }));
};
function openManualAddressEnterPopup(address) {
  return (dispatch, getState) => {
    const {
      enteredAddress,
      suggestedAddress
    } = getAddressesFromStateForAutocompleteSelection(shippingAddressValuesSelector(getState()), address);
    const addresses = [enteredAddress];
    if (suggestedAddress) {
      addresses.push(suggestedAddress);
    }
    dispatch(showManualAddressEnterPopup({
      confirmAddresses: addresses,
      onConfirmAddress: type => dispatch => {
        const {
          isAddressEnteredManually,
          address
        } = getAutocompleteAddressPayload(addresses, type);
        dispatch(setAddressAction(address));
        dispatch(resendAnswer(type, isAddressEnteredManually));
      },
      onEnterAddress: () => dispatch => {
        dispatch(hidePopup());
      }
    }));
  };
}
function openManualAddressErrorPopup() {
  return (dispatch, getState) => {
    const {
      enteredAddress
    } = getAddressesFromStateForAutocompleteSelection(shippingAddressValuesSelector(getState()));
    dispatch(showManualAddressEnterPopup({
      confirmAddresses: [enteredAddress],
      onConfirmAddress: type => dispatch => {
        dispatch(resendAnswer(type, true));
      },
      onEnterAddress: () => dispatch => {
        dispatch(hidePopup());
      }
    }));
  };
}
export const SAVE_FEEDBACK = `${GIVEAWAY_LANDING_STORE_PREFIX}SAVE_FEEDBACK`;
export const saveFeedback = message => ({
  type: SAVE_FEEDBACK,
  payload: message
});
export const saveFeedbackAction = createAsyncLoadedAction({
  fn: GiveawayApi.saveFeedback,
  success: (res, data) => saveFeedback(data.message),
  postSuccess: dispatch => {
    dispatch(showNotification({
      text: 'Thanks! Your note has been sent.'
    }));
  },
  error: (err, data, dispatch) => {
    dispatch(showNotification({
      text: 'Something went wrong while submitting your note.'
    }));
  }
});
export const SET_QUANTITY = `${GIVEAWAY_LANDING_STORE_PREFIX}_SET_QUANTITY`;
export const setQuantity = ({
  variantId,
  quantity
}) => ({
  type: SET_QUANTITY,
  payload: {
    variantId,
    quantity
  }
});
export const BLUR_QUANTITY = `${GIVEAWAY_LANDING_STORE_PREFIX}_BLUR_QUANTITY`;
export const blurQuantity = ({
  id,
  touched
}) => ({
  type: BLUR_QUANTITY,
  payload: {
    id,
    touched
  }
});
export const submitGiveawayLink = () => (dispatch, getState) => {
  const state = getState();
  const giveaway = selectedGiveawaySelector(state);
  const link = giveawayLinkRouteSelector(state);
  if (checkIsGiveawayWithSwagType(giveaway)) {
    return dispatch(saveAnswer());
  }
  if (checkIsGiveawayWithGoodieType(giveaway)) {
    const pathname = pathnameSelector(state);
    const isCheckout = pathname.includes(GiveawayGoodieSteps.checkout);
    if (isCheckout) {
      setGoodieGiveawaySelectedProducts(null, link); //todo put it to request with submit goodie link

      return dispatch(saveAnswer());
    } else {
      const shouldShowBudgetConfirmation = shouldShowGoodieBudgetConfirmationPopup(state);
      if (shouldShowBudgetConfirmation) {
        dispatch(showPopup({
          popup: CONFIRM_GOODIE_UNUSED_BUDGET_POPUP
        }));
        return;
      }
    }
    if (!link) {
      return;
    }
    return browserHistory.push(GiveawayUrl.getGiveawayUserLandingCheckout(link, giveaway === null || giveaway === void 0 ? void 0 : giveaway.giveawayType));
  }
};
export const onConfirmUnusedGoodieBudget = () => (dispatch, getState) => {
  const state = getState();
  const link = giveawayLinkRouteSelector(state);
  const giveawayType = selectedGiveawayTypeSelector(state);
  dispatch(hidePopup());
  return browserHistory.push(GiveawayUrl.getGiveawayUserLandingCheckout(link, giveawayType));
};